import { ClientHistoryRepository } from "@domain/repositories/ClientHistoryRepository";
import { HttpClient } from "@data/api/HttpClient";
import { Client } from "@domain/models/Client";

export class HttpClientHistoryRepository implements ClientHistoryRepository {
  private readonly baseUrl = `${process.env.REACT_APP_API_URL}/client_history`;

  constructor(private readonly httpClient: HttpClient) {}

  async getClientHistory(clientId: Client["id"]) {
    return this.httpClient
      .request({
        method: "GET",
        url: `${this.baseUrl}/${clientId}`,
      })
      .then((response) => {
        return response.data;
      });
  }
}
